import axios from 'axios'

const RESET = 'RESET'
const SET_ALLUNITLIST = 'SET_ALLUNITLIST'
const SET_ALLUNITGROUP = 'SET_ALLUNITGROUP'
const SET_DETAIL = 'SET_DETAIL'
const SET_ConversionInGroup = 'SET_ConversionInGroup'
const AddUnitGroup = 'AddUnitGroup'
const EditUnitGroup = 'EditUnitGroup'
const DeleteUnitGroup = 'DeleteUnitGroup'
const AddUnit = 'AddUnit'
const EditUnit = 'EditUnit'
const DeleteUnit = 'DeleteUnit'
const EditCovert = 'EditCovert'
const EditGroupCovertion = 'EditGroupCovertion'
const AddFormula = 'AddFormula'
const EditFormula = 'EditFormula'
const DeleteFormula = 'DeleteFormula'
const ChangeLoadAllUnits = 'ChangeLoadAllUnits'
const ChangeLoadAllUnitGroups = 'ChangeLoadAllUnitGroups'

function initialState() {
  return {
    allUnitGroups: [],
    allUnits: [],
    isLoadAllUnitGroups: false,
    isLoadAllUnits: false,
    unitDetail: {},
    conversionInGroup: [],
  }
}
import {
  sortObject,
} from '@/helpers/sorting'

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getUnitList({
      commit,
    }) {
      let url = 'api/Units/UnitList'
      try {
        let res = await axios.get(url)
        commit(SET_ALLUNITLIST, res.data)
      } catch (e) {
        console.log('Could not get unit data from \'' + url + '\'')
      }
    },
    async getUnitGroup({
      commit,
    }) {
      let url = 'api/Units/UnitGroups'
      try {
        let res = await axios.get(url)
        commit(SET_ALLUNITGROUP, res.data)
      } catch (e) {
        console.log('Could not get unit data from \'' + url + '\'')
      }
    },
    async getUnitDetail({
      commit,
    }, options) {
      let url = 'api/Units/' + options
      try {
        let res = await axios.get(url)
        commit(SET_DETAIL, res.data)
      } catch (e) {
        console.log('Could not get unit data from \'' + url + '\'')
      }
    },

    async getUnitConversionByGroup({ commit }, options) {
      let url = 'api/Units/ConversionInGroup/' + options
      await axios.get(url)
        .then(res => {
          commit(SET_ConversionInGroup, res.data)
        })
        .catch(() => {
          console.log('Could not get unit conversion data from \'' + url + '\'')
        })
    },

    async postAddUnitGroup({
      commit,
    }, options) {
      let url = 'api/Units/AddOrEditUnitGroup'
      await axios.post(url, options.data)
        .then(res => {
          commit(AddUnitGroup, res.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditUnitGroup({
      commit,
    }, options) {
      let url = 'api/Units/AddOrEditUnitGroup'
      await axios.post(url, options.data)
        .then(res => {
          commit(EditUnitGroup, res.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postDeleteUnitGroup({
      commit,
    }, options) {
      let url = 'api/Units/DeleteUnitGroup'
      var postData = {
        UnitGroupId: options.data.deleteGroupId,
        IsDeleteUnit: options.data.IsDeleteUnit,
      }
      await axios.post(url, postData)
        .then(() => {
          commit(DeleteUnitGroup, options.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postAddUnit({
      commit,
      rootGetters,
    }, options) {
      let url = 'api/Units/AddOrEditUnitDetail'
      var groupsArr = []
      options.data.belongToGroup.forEach(e => {
        rootGetters['unit/allUnitGroups'].forEach(a => {
          if (e == a.Id) {
            groupsArr.push({
              Id: a.Id,
              Name: a.Name,
            })
          }
        })
      })
      var postData = {
        Id: null,
        Name: options.data.unitName,
        Groups: groupsArr,
      }
      await axios.post(url, postData)
        .then(res => {
          options.data.unitId = res.data.Id
          commit(AddUnit, options.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditUnit({
      commit,
      rootGetters,
    }, options) {
      let url = 'api/Units/AddOrEditUnitDetail'
      var groupsArr = []
      options.data.belongToGroup.forEach(e => {
        rootGetters['unit/allUnitGroups'].forEach(a => {
          if (e == a.Id) {
            groupsArr.push({
              Id: a.Id,
              Name: a.Name,
            })
          }
        })
      })
      var postData = {
        Id: options.data.unitId,
        Name: options.data.unitName,
        Groups: groupsArr,
      }
      await axios.post(url, postData)
        .then(() => {
          commit(EditUnit, options.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postDeleteUnit({
      commit,
    }, options) {
      let url = 'api/Units/DeleteUnit/' + options.data
      await axios.post(url)
        .then(() => {
          commit(DeleteUnit, options.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditGroupCovertion({
      commit,
    }, options) {
      let url = 'api/Units/AddOrEditUnitConversion/'
      await axios.post(url, options.data)
        .then(res => {
          commit(EditGroupCovertion, res.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    changeLoadAllUnits({ commit }) {
      commit(ChangeLoadAllUnits)
    },
    changeLoadAllUnitGroups({ commit }) {
      commit(ChangeLoadAllUnitGroups)
    },
  },

  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [SET_ALLUNITLIST](state, data) {
      state.allUnits = data.sort(sortObject('Name'))
    },
    [SET_ALLUNITGROUP](state, data) {
      let unknown = data.find(x => x.Name == 'Unknown')
      if (unknown) {
        let target = JSON.parse(JSON.stringify(unknown))
        let index = data.findIndex(x => x.Name == 'Unknown')
        data.splice(index, 1)
        data.push(target)
      }
      state.allUnitGroups = data
    },
    [SET_DETAIL](state, data) {
      state.unitDetail = data
    },
    [SET_ConversionInGroup](state, data) {
      state.conversionInGroup = data
    },
    [AddUnitGroup](state, data) {
      var dc = JSON.parse(JSON.stringify(state.allUnitGroups))
      var ed = JSON.parse(JSON.stringify(state.allUnits))
      data.Units.forEach(e => {
        let unit = ed.find(i => i.Id == e.Id)
        unit.Groups.push({
          Id: data.Id,
          Name: data.Name,
        })
      })
      dc.push({
        Id: data.Id,
        Name: data.Name,
        Units: data.Units,
      })
      state.allUnitGroups = dc
      state.allUnits = ed
    },
    [EditUnitGroup](state, data) {
      var unitDC = JSON.parse(JSON.stringify(state.allUnits))
      var groupDC = JSON.parse(JSON.stringify(state.allUnitGroups))

      unitDC.forEach(unit => {
        let match = unit.Groups.find(x => x.Id == data.Id)
        let isMember = data.Units.find(x => x.Id == unit.Id)
        if (isMember) {
          if (match) {
            match.Name = data.Name
            return
          } else {
            unit.Groups.push(data)
            return
          }
        } else {
          if (match) {
            var i = unit.Groups.indexOf(match)
            unit.Groups.splice(i, 1)
            return
          }
        }
      })
      var group = groupDC.find(x => x.Id == data.Id)
      group.Units = data.Units
      group.Name = data.Name
      state.conversionInGroup = data.UnitConverts
      state.allUnits = unitDC
      state.allUnitGroups = groupDC
    },
    [DeleteUnitGroup](state, data) {
      var dc = JSON.parse(JSON.stringify(state.allUnitGroups))
      var ed = JSON.parse(JSON.stringify(state.allUnits))
      if (data.IsDeleteUnit == false) {
        let deleteGroup = dc.find(e => e.Id == data.deleteGroupId)
        ed.forEach(a => {
          a.Groups.forEach(i => {
            if (i.Id == data.deleteGroupId) {
              a.Groups.splice(a.Groups.indexOf(i), 1)
            }
          })
        })
        dc.splice(dc.indexOf(deleteGroup), 1)
      } else {
        let deleteGroup = dc.find(e => e.Id == data.deleteGroupId)
        let delUnit = []
        dc.forEach(e => {
          if (e.Id == data.deleteGroupId) {
            e.Units.forEach(a => {
              delUnit.push(a.Id)
            })
          }
        })
        delUnit.forEach(a => {
          let deleteUnit = ed.find(e => e.Id == a)
          ed.splice(ed.indexOf(deleteUnit), 1)
        })
        dc.splice(dc.indexOf(deleteGroup), 1)
        dc.forEach(a => {
          a.Units.forEach(b => {
            delUnit.forEach(c => {
              if (b.Id == c) {
                a.Units.splice(a.Units.indexOf(b), 1)
              }
            })
          })
        })
      }
      state.allUnitGroups = dc
      state.allUnits = ed
    },
    [AddUnit](state, data) {
      var dc = JSON.parse(JSON.stringify(state.allUnitGroups))
      var ed = JSON.parse(JSON.stringify(state.allUnits))
      let unitgroup = []
      data.belongToGroup.forEach(e => {
        let group = dc.find(i => i.Id == e)
        group.Units.push({
          Id: data.unitId,
          Name: data.unitName,
        })
        unitgroup.push({
          Id: group.Id,
          Name: group.Name,
        })
      })
      ed.push({
        Id: data.unitId,
        Name: data.unitName,
        Groups: unitgroup,
      })
      state.allUnitGroups = dc
      state.allUnits = ed
    },
    [EditUnit](state, data) {
      var dc = JSON.parse(JSON.stringify(state.allUnitGroups))
      var ed = JSON.parse(JSON.stringify(state.allUnits))
      let groups = []
      data.belongToGroup.forEach(e => {
        let group = dc.find(i => i.Id == e)
        groups.push({
          Id: group.Id,
          Name: group.Name,
        })
      })

      let editUnit = ed.find(e => e.Id == data.unitId)
      let i = ed.indexOf(editUnit)
      ed.splice(i, 1, {
        Id: data.unitId,
        Name: data.unitName,
        Groups: groups,
      })
      let str1 = []
      dc.forEach(a => {
        a.Units.forEach(b => {
          if (b.Id == data.unitId) {
            str1.push(a.Id)
          }
        })
      })
      let str2 = data.belongToGroup
      let str3 = [...str1, ...str2]
      str3 = Array.from(new Set(str3))
      let str4 = str3 //add
      for (let x in str1) {
        for (let y in str4) {
          if (str1[x] == str4[y]) {
            str4.splice(y, 1)
          }
        }
      }
      str3 = [...str1, ...str2]
      str3 = Array.from(new Set(str3))
      let str5 = str3 //del
      for (let x in str2) {
        for (let y in str5) {
          if (str2[x] == str5[y]) {
            str5.splice(y, 1)
          }
        }
      }
      let str6 = [] //same
      for (let x in str1) {
        for (let y in str2) {
          if (str1[x] == str2[y]) {
            str6.push(str1[x])
          }
        }
      }
      str4.forEach(a => { //add
        dc.forEach(b => {
          if (a == b.Id) {
            b.Units.push({
              Id: data.unitId,
              Name: data.unitName,
            })
          }
        })
      })
      str5.forEach(a => { //del
        dc.forEach(b => {
          if (a == b.Id) {
            let del = b.Units.find(c => c.Id == data.unitId)
            b.Units.splice(b.Units.indexOf(del), 1)
          }
        })
      })
      str6.forEach(a => { //same
        dc.forEach(b => {
          if (a == b.Id) {
            let chag = b.Units.find(c => c.Id == data.unitId)
            b.Units.splice(b.Units.indexOf(chag), 1, {
              Id: data.unitId,
              Name: data.unitName,
            })
          }
        })
      })
      state.allUnitGroups = dc
      state.allUnits = ed
    },
    [DeleteUnit](state, data) {
      var dc = JSON.parse(JSON.stringify(state.allUnitGroups))
      var ed = JSON.parse(JSON.stringify(state.allUnits))
      dc.forEach(e => {
        for (var i in e.Units) {
          if (e.Units[i].Id == data) {
            e.Units.splice(i, 1)
          }
        }
      })
      let deleteUnit = ed.find(a => a.Id == data)
      ed.splice(ed.indexOf(deleteUnit), 1)
      state.allUnitGroups = dc
      state.allUnits = ed
    },
    [EditCovert](state, data) {
      var dc = JSON.parse(JSON.stringify(state.unitDetail))
      dc.ConvertInfo.forEach(e => {
        if (e.Id == data.Id) {
          e.Formula == data.Formula
        }
      })
      state.unitDetail = dc
    },
    [EditGroupCovertion](state, data) {
      var dc = JSON.parse(JSON.stringify(state.conversionInGroup))
      dc.forEach(e => {
        if (e.Id == data.Id) {
          e.Formula = data.Formula
        }
      })
      state.conversionInGroup = dc
    },
    [AddFormula](state, data) {
      var dc = JSON.parse(JSON.stringify(state.unitDetail))
      let toUnit = state.allUnits.find(e => e.Id == data.ToUnitId)
      dc.ConvertInfo.push({
        Id: data.Id,
        FromUnitId: dc.Id,
        FromUnit: dc.Name,
        ToUnitId: data.ToUnitId,
        ToUnit: toUnit.Name,
        Formula: data.Formula,
        NumberOfDecimal: data.NumberOfDecimal,
      })
      state.unitDetail = dc
    },
    [EditFormula](state, data) {
      var dc = JSON.parse(JSON.stringify(state.unitDetail))
      let formula = dc.ConvertInfo.find(e => e.Id == data.Id)
      formula.Formula = data.Formula
      formula.NumberOfDecimal = data.NumberOfDecimal
      state.unitDetail = dc
    },
    [DeleteFormula](state, data) {
      var dc = JSON.parse(JSON.stringify(state.unitDetail))
      for (var i in dc.ConvertInfo) {
        if (dc.ConvertInfo[i].Id == data) {
          dc.ConvertInfo.splice(i, 1)
        }
      }
      state.unitDetail = dc
    },
    [ChangeLoadAllUnits](state) {
      state.isLoadAllUnits = !state.isLoadAllUnits
    },
    [ChangeLoadAllUnitGroups](state) {
      state.isLoadAllUnitGroups = !state.isLoadAllUnitGroups
    },
  },

  getters: {
    'allUnitGroups': (state) => state.allUnitGroups,
    'allUnits': (state) => state.allUnits,
    'unitDetail': (state) => state.unitDetail,
    'isLoadAllUnits': (state) => state.isLoadAllUnits,
    'isLoadAllUnitGroups': (state) => state.isLoadAllUnitGroups,
    'conversionInGroup': (state) => state.conversionInGroup,
  },
}

const normalizeUnitName = (unitName) => {
  const unitNameIsString = typeof unitName === 'string' || unitName instanceof String
  return unitNameIsString ? unitName.toLowerCase().replace(/\s/g, '') : unitName
}
/**
 * Compare unit names by normalizing comparison method
 * #18044
 */
const checkUnitNamesEqual = (unitName1, unitName2) => {
  return normalizeUnitName(unitName1) == normalizeUnitName(unitName2)
}

export { normalizeUnitName, checkUnitNamesEqual }